import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  proveedorManualApi,
  type BuscarProveedoresParams,
} from "@/features/proveedor-manual/services/proveedor-manual.api";

export const proveedoresBuscarQueryOptions = (params: BuscarProveedoresParams = {}) =>
  queryOptions({
    queryKey: qk.proveedoresBuscar(params),
    queryFn: () => proveedorManualApi.buscar(params),
    placeholderData: keepPreviousData,
  });

export function useProveedoresBuscar(params: BuscarProveedoresParams = {}) {
  return useQuery(proveedoresBuscarQueryOptions(params));
}
